module.exports = __webpack_public_path__ + "static/gallery_yarra_4_thumb-d40d95c437e40e130395a78c52236dee.jpg";